/* istanbul ignore file */
import { array as codecArray, number as codecNumber } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const ReorderAssignmentsCourseDataParser = 
/* #__PURE__ */ parsers.object([
    ['assignmentIds', /* #__PURE__ */ codecArray(codecNumber), 'assignment_ids'],
]);
export class ReorderAssignmentsCourseData extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return ReorderAssignmentsCourseDataParser.decode(input).map(res => new ReorderAssignmentsCourseData(res));
    }
    static unsafeDecode(input) {
        return ReorderAssignmentsCourseData.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return ReorderAssignmentsCourseDataParser.encode(data);
    }
    static schema() {
        return ReorderAssignmentsCourseDataParser.schema();
    }
}
